<script setup>
import { loadScript } from "@/utils/netease-validate";
import jsbridge from "@/utils/jsbridge";
import { getCurrentInstance } from "vue";

loadScript(
  `https://static.aipiaxi.com/app/web/libs/YiDunProtector-Web-2.0.3.js`,
  () => {
    window.neg = createNEGuardian({
      appId: "YD00235410927774",
      timeout: 10000,
    });
  }
);

loadScript(`https://acstatic-dun.126.net/tool.min.js?t=${Date.now()}`, () => {
  window.initWatchman({
    productNumber: "YD00235410927774",
    onload: function (instance) {
      window.wm = instance;
    },
  });
});

loadScript(`https://static.aipiaxi.com/app/web/libs/vconsole.min.js`, () => {
  if (process.env.VUE_APP_VCONSOLE) {
    new VConsole();
  }
});

if (getCurrentInstance().proxy.$route.query.debug) {
  new VConsole();
}
</script>

<template>
  <router-view :key="$route.path"></router-view>
</template>
